// extracted by mini-css-extract-plugin
module.exports = {"container":"MixedBlock_container__OVECx","media":"MixedBlock_media__tvIlI","text":"MixedBlock_text__18ja2"};